import type { Questions } from '../Types/Questions'

const questions = {
  onlyNational: {
    depenses: {
      id: 'depenses',
      answers: {
        national: 114,
        description: (
          <>
            <p>
              La famille royale britannique a dépensé un total de 114 millions
              de francs suisses en 2020/21. L'entretien des biens et le salaire
              des employés représentent 85% de ces dépenses. Viennent ensuite
              les frais de voyage de la famille royale (tout de même 4,5
              millions de livres), les services et l'entretien des résidences.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Combien dépense la famille royale en une année?',
        description: 'En millions de francs suisses',
        unit: 'millions',
        min: 2,
        max: 150,
        year: 2021,
        source: [
          {
            sourceTitle: 'Statista',
            sourceUrl:
              'https://www.statista.com/statistics/372882/uk-royal-family-expenditure-breakdown/',
          },
        ],
      },
    },
    heritage: {
      id: 'heritage',
      answers: {
        national: 420,
        description: (
          <>
            <p>
              Aucun chiffre officiel n’étant divulgué, on estime que le roi a
              hérité des 375 millions de livres sterling de fortune personnelle
              de la reine Elizabeth (420 millions de francs), sans avoir à payer
              de taxe de succession, car les souverains en sont exempts.
            </p>
            <p>
              Il hérite également du duché de Lancaster, un domaine privé
              appartenant à la famille royale depuis le Moyen Age, qui a comme
              objectif principal de fournir une source de revenus au monarque et
              qui génère 24 millions de livres par année.
            </p>
            <p>
              À cela s’ajoutent les biens de la Couronne, dont le nouveau roi a
              la jouissance, ainsi que le «Sovereign Grant», une allocation
              annuelle attribuée à la famille royale pour financer ses
              activités. Elle s’est élevée à 86 millions de livres en 2021-2022.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'De combien de millions le roi Charles a-t-il hérité au décès de la reine Elizabeth?',
        description: 'En millions de francs suisses',
        unit: 'millions',
        min: 10,
        max: 900,
        year: 2021,
        source: [
          {
            sourceTitle: 'Businessinsider',
            sourceUrl:
              'https://www.businessinsider.com/queen-elizabeth-net-worth-2017-8?r=UK&IR=',
          },
          {
            sourceTitle: ', site officiel du duché de Cornouailles',
            sourceUrl: 'https://duchyofcornwall.org/financials.html',
          },
          {
            sourceTitle: ', site officiel de la Couronne',
            sourceUrl: 'https://www.royal.uk/sovereign-grant',
          },
        ],
      },
    },
    fortune: {
      id: 'fortune',
      answers: {
        national: 28,
        description: (
          <>
            <p>
              La fortune totale de la famille royale, qui comprend la valeur des
              biens immobiliers comme Buckingham Palace (5 mia de francs),
              Kensigton Palace (600 mio de francs) et surtout le Crown Estate –
              le trust qui gère la fortune de la famille royale –, est estimée
              en 2021 à plus de 28 milliards de francs par le magazine Forbes.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Quelle est la fortune totale de la famille royale?',
        description: 'En milliards de francs suisses',
        unit: 'milliards',
        min: 1,
        max: 30,
        year: 2021,
        source: [
          {
            sourceTitle: 'Forbes',
            sourceUrl:
              'https://www.forbes.com/sites/arielshapiro/2021/03/10/inside-the-firm-how-the-royal-familys-28-billion-money-machine-really-works/?sh=188266122bcc',
          },
        ],
      },
    },
    employes: {
      id: 'employes',
      answers: {
        national: 1200,
        description: (
          <>
            <p>
              Le staff de la famille royale compte environ 1200 personnes,
              chargées de la sécurité, de la communication, de l'administration,
              de la maintenance des propriétés royales, des soins aux animaux,
              de la cuisine, de la garde-robe, des affaires protocolaires et
              bien d'autres choses. Les salaires du personnel sont financés par
              le Sovereign Grant.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Combien de personnes sont employées par la famille royale?',
        description:
          'Sécurité, communication, administration, maintenance, etc. ',
        unit: 'employés',
        min: 10,
        max: 5000,
        year: 2021,
        image: 'staff',
        imagePosition: 'center',
        source: [
          {
            sourceTitle: 'Daily Express',
            sourceUrl:
              'https://www.express.co.uk/news/royal/1022721/royal-family-news-how-many-staff-members-buckingham-palace',
          },
        ],
      },
    },
    regne: {
      id: 'regne',
      answers: {
        national: 70,
        description: (
          <>
            <p>
              La reine Elizabeth, qui avait 18 ans à son couronnement, a régné
              pendant 70 ans, 7 mois et 2 jours. Elle a facilement battu le
              record du monarque britannique le plus âgé.
            </p>
            <p>
              Quant au prince Charles, qui a 74 ans, il sera le roi le plus âgé
              de tous les monarques lors son couronnement. Il devrait rester sur
              le trône jusqu’à l’âge de 144 ans pour dépasser la durée du règne
              de sa mère.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Combien de temps la reine Elizabeth a-t-elle régné?',
        description: null,
        unit: 'ans',
        min: 30,
        max: 100,
        year: 2021,
        source: [
          {
            sourceTitle: 'BBC',
            sourceUrl: 'https://www.bbc.com/news/uk-34177107',
          },
        ],
      },
    },
    // longevite: {
    //   id: 'longevite',
    //   answers: {
    //     national: 144,
    //     description: (
    //       <>
    //         <p>
    //           La reine Elizabeth, qui avait 18 ans à son couronnement, a régné
    //           pendant 70 ans, 7 mois et deux jours. Le prince Charles, âgé de 74
    //           ans, devrait vivre jusqu’à 144 ans pour battre ce record.
    //         </p>
    //       </>
    //     ),
    //   },
    //   meta: {
    //     question:
    //       'Jusqu’à quel âge le prince Charles devrait-il vivre pour régner aussi longtemps que la reine Elizabeth?',
    //     description: 'Pourcentage de la population résidente',
    //     unit: 'ans',
    //     min: 80,
    //     max: 180,
    //     year: 2021,
    //     source: [{
    //       sourceTitle: 'Etude MACH',
    //       sourceUrl: 'https://www.swissveg.ch/node/3567?language=fr',
    //     }],
    //   },
    // },
    ecole: {
      id: 'ecole',
      answers: {
        national: 8,
        description: (
          <>
            <p>
              Le roi Charles avait un tuteur personnel presque jusqu’à ses 8
              ans. Il a commencé à fréquenter l’école à 7 ans, une semaine avant
              son 8e anniversaire. Charles a donc fait sa rentrée le 7 novembre
              1956 à la Hill House School, une école préparatoire dans l’ouest
              de Londres.
            </p>
            <p>
              Par la suite, il a fréquenté plusieurs autres écoles, dont Cheam
              School et Gordonstoun en Écosse, avant d'étudier l'archéologie et
              l'anthropologie à l'Université de Cambridge.
            </p>
          </>
        ),
      },
      meta: {
        question: 'À quel âge Charles a-t-il commencé l’école?',
        description: null,
        unit: 'ans',
        min: 2,
        max: 20,
        year: 2021,
        source: [
          {
            sourceTitle: 'Site officiel du Prince de Galles',
            sourceUrl:
              'https://www.princeofwales.gov.uk/biographies/hrh-prince-wales',
          },
        ],
      },
    },
    elizabeth: {
      id: 'elizabeth',
      answers: {
        national: 0,
        description: (
          <>
            <p>
              Aucune! La reine n’avait pas de permis. Selon la loi britannique,
              le monarque est dispensé de cette obligation car les permis sont
              délivrés en son nom. Ce privilège, qui ne s’applique pas aux
              autres membres de la famille royale, s’étend désormais au roi
              Charles.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien de fois la reine Elizabeth s’est-elle fait pincer en conduisant sans permis de conduire?',
        description: null,
        unit: '',
        min: 0,
        max: 5,
        year: 2021,
        source: [
          {
            sourceTitle: 'Daily Express',
            sourceUrl:
              'https://www.express.co.uk/news/royal/1515081/queen-elizabeth-II-driving-licence-evg',
          },
        ],
      },
    },
    horses: {
      id: 'horses',
      answers: {
        national: 30,
        description: (
          <>
            <p>
              Dans les écuries de Buckingham Palace, les Royal Mews, se trouvent
              les 30 chevaux de la famille royale. C’est aussi là que sont
              conservés les attelages, carrosses, voitures et autres moyens de
              transport terrestre de la famille royale, notamment le fameux
              Golden State Coach. Cet énorme carrosse de 4 tonnes recouvert de
              feuilles d’or est utilisé pour tous les couronnements depuis 1831.
            </p>
            <p>
              À sa mort, la presse britannique a estimé que la reine possédait
              une centaine de chevaux au total, dont de nombreux champions de
              course. En l'espace de quelques semaines, Charles a commencé à
              vendre 30 de ces purs-sangs qu’il a hérités, ce qui lui aurait
              rapporté plus de 2,25 millions de livres sterling, d’après le
              <i>Guardian</i>.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien de chevaux possède la famille royale à Buckingham Palace?',
        description: null,
        image: 'chevaux',
        imagePosition: '30%',
        unit: '',
        min: 1,
        max: 100,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection',
            sourceUrl:
              'https://www.rct.uk/visit/the-royal-mews-buckingham-palace/the-gold-state-coach#/',
          },
          {
            sourceTitle: 'The Independant',
            sourceUrl:
              'https://www.independent.co.uk/life-style/royal-family/queen-horses-what-will-happen-b2163594.html',
          },
          {
            sourceTitle: 'The Guardian',
            sourceUrl:
              'https://www.theguardian.com/uk-news/2023/apr/07/all-the-queens-horses-and-their-27m-value-to-the-new-king',
          },
        ],
      },
    },
    touristes: {
      id: 'touristes',
      answers: {
        national: 737000,
        description: (
          <>
            <p>
              737’000 visiteurs ont visité les résidences royales britanniques
              entre 2021 et 2022. Les sites les plus populaires du domaine royal
              sont le château de Windsor et la Frogmore House. Ce tourisme royal
              génère près de 50 millions de livres sterling rien qu’avec la
              vente de billets d’entrée.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien de touristes ont visité le domaine royal l’an passé?',
        description: null,
        unit: '',
        min: 100000,
        max: 1000000,
        year: 2021,
        source: [
          {
            sourceTitle: 'Rapport annuel de la Royal Collection',
            sourceUrl:
              'https://www.rct.uk/sites/default/files/resources/Annual%20Report%202021-22.pdf',
          },
        ],
      },
    },
    youtube: {
      id: 'youtube',
      answers: {
        national: 3000000,
        description: (
          <>
            <p>
              À un mois du couronnement, The Royal Family Channel, la chaîne
              officielle de la monarchie britannique, compte plus de 3 millions
              de followers. On y trouve plus de 4000 vidéos, dont des vidéos
              familiales - Charles en maillot de bain ou Diana qui joue avec
              William encore bébé.
            </p>
            <p>
              Certains événements sont diffusés en direct sur la chaîne, mais on
              ignore encore si la cérémonie du couronnement le sera…
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien de followers suivent la chaîne Youtube de la famille royale?',
        description: null,
        unit: '',
        min: 100000,
        max: 50000000,
        year: 2021,
        source: [
          {
            sourceTitle: 'Youtube',
            sourceUrl: 'https://www.youtube.com/@royalchannel',
          },
        ],
      },
    },
    art: {
      id: 'art',
      answers: {
        national: 1000000,
        description: (
          <>
            <p>
              La collection d’art de la famille royale est constituée d’un
              million d'œuvres. Une base de données en ligne permet de parcourir
              près de 270’000 objets.
            </p>
            <p>
              On y trouve des Rembrandt, Vermeer et Van Dyck, mais aussi des
              curiosités comme une miniature de boîte de lait condensé Nestlé
              qui provenait de la maison de poupée de la reine Mary, ou encore
              un dessin de la Jungfrau par la reine Victoria lors de son séjour
              à Lucerne en 1868.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien d’objets contient la collection d’art de la famille royale?',
        description: null,
        unit: '',
        image: 'art',
        imagePosition: 'center',
        min: 200000,
        max: 10000000,
        year: 2021,
        source: [
          {
            sourceTitle: 'The Royal Collection',
            sourceUrl: 'https://www.royalcollection.org.uk/collection/about',
          },
        ],
      },
    },
    souvenirs: {
      id: 'souvenirs',
      answers: {
        national: 12,
        description: (
          <>
            <p>
              Le magasin en ligne et les boutiques touristiques ont vendu pour
              10,7 millions de livres sterling (12 millions de francs) de
              merchandising lié à la famille royale. La gamme de souvenirs
              allant de la couverture de picnic au service à thé.
            </p>
            <p>
              Parmi les innovations de 2022, on trouve notamment la nouvelle
              gamme de bijoux fabriquée à partir de boîtes à biscuits recyclées.
            </p>
          </>
        ),
      },
      meta: {
        question: 'Combien de millions rapporte la vente de souvenirs royaux?',
        description: 'En millions de francs suisses',
        unit: 'millions',
        min: 2,
        max: 50,
        year: 2021,
        source: [
          {
            sourceTitle: 'Rapport annuel de la Royal Collection',
            sourceUrl:
              'https://www.rct.uk/sites/default/files/resources/Annual%20Report%202021-22.pdf',
          },
        ],
      },
    },
    couronne: {
      id: 'couronne',
      answers: {
        national: 23578,
        description: (
          <>
            <p>
              Il y a 23 578 pierres précieuses dans les joyaux de la Couronne,
              qui sont conservées à la Tour de Londres. Le sceptre du souverain
              avec croix, utilisé lors de chaque couronnement depuis Charles II
              en 1661, est orné du diamant Cullinan I. Ce diamant, le plus gros
              diamant blanc taillé de qualité supérieure au monde, pèse 530
              carats.
            </p>
            <p>
              En 1908, la pierre était évaluée à 2,5 millions de dollars
              américains (l'équivalent de 55 millions de dollars aujourd’hui),
              mais cette estimation reste probablement très en dessous du prix
              qu’atteindrait la pierre si elle devait être vendue – ce qui est
              évidemment inimaginable. Elizabeth II possédait sept autres
              diamants majeurs, hérités de sa grand-mère, la reine Mary, en
              1953.
            </p>
          </>
        ),
      },
      meta: {
        question:
          'Combien de pierres précieuses contiennent les Joyaux de la Couronne?',
        description: null,
        unit: '',
        min: 1000,
        max: 50000,
        year: 2021,
        source: [
          {
            sourceTitle: 'Royal Collection',
            sourceUrl:
              'https://www.rct.uk/collection/themes/trails/the-crown-jewels/the-cullinan-diamond',
          },
        ],
      },
    },
  },
}

export default questions as unknown as Questions
